import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";

function useInventoryNotes(params) {
  return useSWR(
    {
      path: "/api/v1/inventory-notes",
      method: "GET",
      params: {
        limit: 50,
        skip: 0,
        ...params,
      },
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useInventoryNotes;
